/**
 * Consent state for analytics and marketing.
 * Updated by consentBridge when Axeptio fires cookies:complete or consent:saved.
 * Read by analytics module to gate all tracking.
 */

let analyticsConsentGranted = false;
let marketingConsentGranted = false;

export function setAnalyticsConsentGranted(value: boolean): void {
  analyticsConsentGranted = value;
}

export function setMarketingConsentGranted(value: boolean): void {
  marketingConsentGranted = value;
}

export function hasAnalyticsConsent(): boolean {
  return analyticsConsentGranted;
}

export function hasMarketingConsent(): boolean {
  return marketingConsentGranted;
}
